import axios from "axios";
import { setClearCacheError, setClearCacheLoading, setClearCacheSuccess } from "../redux/reducer/clearCacheReducer";
import { errorHandler } from "../utils/utils";

const ADMIN_SERVICE = process.env.REACT_APP_ADMIN_SERVICE;

export const clearCacheApi = async ({ token, dispatch }) => {
  dispatch(setClearCacheLoading());
  try {
    const res = await axios.get(`${ADMIN_SERVICE}/Cache/ClearCache`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    dispatch(setClearCacheSuccess(res.data))
  } catch (err) {
    errorHandler(err, "" ,`${ADMIN_SERVICE}/Cache/ClearCache`)
    dispatch(setClearCacheError(err))
  }
}